// Dosyanin baytlari backend'e ugramaz, dogrudan Cloudinary'ye gider.
// fetch yukleme ilerlemesi bildirmedigi icin XMLHttpRequest kullaniliyor —
// ilerleme cubugu istendigi surece baska secenek yok.

/**
 * @returns {{ promise: Promise<{url: string, publicId: string}>, abort: () => void }}
 */
export function uploadToCloudinary({ upload, file, onProgress }) {
  const xhr = new XMLHttpRequest();

  const promise = new Promise((resolve, reject) => {
    const form = new FormData();
    form.append('file', file);
    form.append('api_key', upload.apiKey);
    // Imzalanan alanlar AYNEN gidiyor. Biri eksik/fazla olursa imza tutmaz ve
    // Cloudinary 401 doner.
    Object.entries(upload.params).forEach(([key, value]) => {
      form.append(key, String(value));
    });

    xhr.open('POST', upload.uploadUrl);

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && onProgress) {
        onProgress(event.loaded / event.total);
      }
    };

    xhr.onload = () => {
      let data;
      try {
        data = JSON.parse(xhr.responseText);
      } catch {
        reject(new Error('Cloudinary yanıtı okunamadı.'));
        return;
      }
      if (xhr.status < 200 || xhr.status >= 300) {
        reject(new Error(data?.error?.message || 'Yükleme başarısız oldu.'));
        return;
      }
      resolve({
        // Videoda secure_url ham dosyayi gosterir; kaydedilecek olan 720p turev.
        url: upload.resourceType === 'video' ? upload.deliveryUrl : data.secure_url,
        publicId: data.public_id,
      });
    };

    xhr.onerror = () => reject(new Error('Ağ hatası, yükleme tamamlanamadı.'));
    xhr.onabort = () => reject(new Error('Yükleme iptal edildi.'));

    xhr.send(form);
  });

  return { promise, abort: () => xhr.abort() };
}
